import React from "react";
import "./home.css";
import TypeAnimation from 'react-type-animation';
 

import { FaLinkedinIn,FaGoogleDrive,FaGithub,FaFacebookF,FaInstagram,FaHandPeace,FaMediumM } from "react-icons/fa";

 
function Home() {
  return (
    <div className="home__main">
    
      <h2>
        {" "}
        Hi All, I'm <span style={{ color: "#87209e" }}> Trishna</span>
         <span className="wave" role="img" aria-labelledby="wave">☺️</span>
         <br />
        <span style={{ color: "#87209e", fontSize: "2rem" }}>
        <TypeAnimation
        cursor={true}
        sequence={[
          'Front-End Enthusiast',
          2000,
          'React Developer',
          2000,
          'SWE Intern @Intuit',
        ]}
        wrapper="a"
        repeat={3}
       />
        </span>
        
      </h2>

      <div
        className="home col-sm-8"
        style={{
          background: "#3d3b3b27",
          display: "inline-block",
          justifyContent: "center",
          color: "white",
          fontFamily: "Lato",
        }}
      >
        <div className="col-sm-3" style={{ padding: "1rem" }}>
          {" "}
          <span style={{ color: "white", fontSize: "1.5rem" }}>
            {" "}
            LET'S HAVE A SMALL{" "}
          </span>
          <span style={{ color: "#b23ae2", fontSize: "1.5rem" }}>
            INTRODUCTION!
          </span>
        </div>

        <div className="container" style={{display:'flex'}}>
          
          <div
            className="row col-center col-sm-4"
            style={{ marginBottom: "1.2rem" }}
          >    
            <p
              style={{
                fontSize: "1.1rem",
                padding:"1rem",
                fontStyle: "italic",
                fontFamily: "lato",
                color: "white",
                textAlign: "justify",
                textJustify: "inter-word"
              }}
            >
         
              Hi, I'm a final year undergraduate from National Institute of Technology,
              Silchar, from the department of Electronics and Communication Engineering. I am currently working as SWE Intern at Intuit with the Enterprise Data and Reporting team.
              I started off as an Android developer in the first academic year and gradually started exploring the web domain.
              I have a good hold over <span style={{ color: "#b23ae2 " }}>
              Javascript and ReactJs
            </span>  and I love building the client side of any web or android application.
              I'm sure if you go through this website, you will get to know more
              about my techy side!
             
              <br />
            </p>
            
            <p
              style={{
                fontSize: "1.1rem",
                fontStyle: "italic",
                fontFamily: "lato",
                color: "white",
              }}
            >
              Another thing that I don't think will mention much, I'm a Kathak
              Dancer!{" "}
            </p>
        
          </div>
          
         
        </div>
        <p style={{
          fontSize: "1.1rem",
          fontStyle: "italic",
          fontFamily: "lato",
          color: "white",
        }}>
        Feel free to <span style={{color:"#b23ae2"}}>connect </span>with me <FaHandPeace/>
      </p>
        <div className="col-12 col-sm-4" style={{display:'inline-flex'}}>
       
        <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/trishnakalita660"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaGithub />
                </a>
              </li>
               
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/trishna-k-565216b6/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/trishna__01/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaInstagram />
                </a>
              </li>
              <li className="social-icons">
              <a
                href="https://www.facebook.com/trishna.kalita.184007"
                target="_blank"
                rel="noreferrer"
                className="icon-colour home-social-icons"
              >
                <FaFacebookF />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://drive.google.com/file/d/1JYWfGoBcEsAYtHdZi3Qbxc6-UDNLClOK/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
                className="icon-colour home-social-icons"
              >
                <FaGoogleDrive />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://medium.com/@trishnakalita"
                target="_blank"
                rel="noreferrer"
                className="icon-colour home-social-icons"
              >
                <FaMediumM />
              </a>
            </li>
            
            </ul>
        
    </div>
      
      </div>
    </div>
  );
}

export default Home;

// <div className="home__main">
// <FadeTransform in transformProps={{
//   exitTransform: 'scale(1.0) translateY(-50%)'
// }}>
// <div className="row">
// <div className="col-6 col-sm">

//   <h2 style={{fontSize :'3vw'}}>
//     HELLO VISITOR...! <br />
//     <span style={{fontSize:'4vw',marginTop:'1rem',fontFamily:'Yusei Magic'}}>
//       {" "}
//       I'm TRISHNA <span style={{ color: "yellow" }}>KALITA</span>
//     </span>

//   <div >
//   <img
//   src="https://miro.medium.com/max/1838/0*xMaFF2hSXpf_kIfG.jpg"
//   alt="trishna"
//   style={{
    // height: "18rem",
    // width: "18rem",
    // paddingRight: "5rem",
    // marginTop: "3rem",
    // marginRight: "5rem",
    // borderRadius: "50%",
    // padding: "3rem",
    // position:'inherit'
//   }}
// />
//  </div>
//  </h2> </div>
//  </div>

//         <div
//           className="col-7 offset-1 col-sm-5 col-center home "
//           style={{
//             background: "#3d3b3b27",
//             display: "inline-block",
//             justifyContent: "center",
//             width: "79%",
//             color: "white",
//             fontFamily: "Lato",
//           }}
//         >
//           <div className="col-sm-3">
//           <h3 style={{textAlign:'center'}}>
//           {" "}
//           LET'S HAVE A SMALL{" "}
//           <span style={{ color: "yellow" }}>INTRODUCTION!</span>
//         </h3>
//           </div>

// <div
//   className="row col-center col-sm-4"
//   style={{ marginBottom: "1rem" }}
// >
//   <p
//     style={{
//       fontSize: "1rem",
//       fontStyle: "italic",
//       fontFamily: "lato",
//       color: "aquamarine",
//     }}
//   >

//   I'm a tech-enthusiast from National Institute of Technology,
//   Silchar, who is currently in 3rd year of her academic year!Talking
//   about my development journey, I started off as an Android developer
//   in the 2nd academic year and gradually started exploring the
//   web domain. I hold the postion of Android Moderator in the Google
//   Developers Club, NIT Silchar in the 2nd academic year itself and is
//   now working as a ReactJs Intern at Tekie Labs. I'm sure if you go
//   through this website, you will get to know more about my techy side!
//   <br/>
//   </p>
//   <p style={{
//     fontSize: "1rem",
//     fontStyle: "italic",
//     fontFamily: "lato",
//     color: "aquamarine",
//   }}>Another thing that I don't think will mention much, I'm a
//   Kathak Dancer!  </p>
// </div>
//           <div
//             className="col-12 col-center col-sm-4 align-item-center"
//             style={{ marginBottom: "1rem" }}
//           >
//           </div>
//         </div>

// </FadeTransform>

// </div>
